<style lang="scss">
  @use "./checkbox";
</style>

<script>
  import Icon from "../Icon.svelte";
  import { getMultiCheckboxContext } from "./context.svelte";

  let { shape = "square", class: cls, ...restProps } = $props();

  const multiCheckboxState = getMultiCheckboxContext();
  if (!multiCheckboxState) {
    throw new Error(
      "MultiCheckbox requires a call to createMultiCheckboxContext within a parent component",
    );
  }

  let isHovered = $state(false);
  let ariaChecked = $derived(multiCheckboxState.all);

  const ICONS = {
    true: "fa-regular fa-check",
    mixed: "fa-regular fa-minus",
    false: "",
  };

  let icon = $derived(
    isHovered ? "fa-regular fa-check" : ICONS[ariaChecked] || "",
  );

  const onclick = (e) => {
    const next = ariaChecked !== "true";
    multiCheckboxState.all = next;
    e.stopPropagation();
  };
  const onmouseenter = () => {
    isHovered = true;
  };
  const onmouseleave = () => {
    isHovered = false;
  };
  const onfocus = () => {
    isHovered = true;
  };
  const onblur = () => {
    isHovered = false;
  };
</script>

<button
  class="{cls} {shape}"
  {onclick}
  {onmouseenter}
  {onmouseleave}
  {onfocus}
  {onblur}
  {...restProps}
  role="checkbox"
  aria-checked={ariaChecked}
>
  <Icon class={icon} size="small" />
</button>
